import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { JOVINO } from "@/config/jovino";

const SiteConfigContext = createContext(JOVINO);

const mergeConfig = (remote) => {
  if (!remote || typeof remote !== "object") return JOVINO;
  return {
    ...JOVINO,
    ...remote,
    token: { ...JOVINO.token, ...(remote.token || {}) },
    presale: { ...JOVINO.presale, ...(remote.presale || {}) },
    whitepaper: remote.whitepaper || JOVINO.whitepaper,
    socials: remote.socials || JOVINO.socials,
  };
};

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(JOVINO);

  useEffect(() => {
    const api = `${process.env.REACT_APP_BACKEND_URL}/api`;
    axios
      .get(`${api}/config`)
      .then((res) => setConfig(mergeConfig(res.data)))
      .catch(() => setConfig(JOVINO));
  }, []);

  return <SiteConfigContext.Provider value={config}>{children}</SiteConfigContext.Provider>;
};

export const useSiteConfig = () => useContext(SiteConfigContext);
